<template>
  <main>
    <header>
      <h2>{{info.Name}}</h2>
      <b class="price">{{info.min_price}}</b>
      <ul class="promise">
        <li><i class="icon-shijian00"></i><span>{{ info | getCycle }}</span></li>
        <li v-for="v in info.Promises" :key="v"><i class="icon-gouxuan"></i><span>{{ v }}</span></li>
      </ul>
      <ul class="tags">
        <li>{{ info.KindName }}</li>
        <li>{{ info.FormName }}</li>
      </ul>
      <ul class="desc">
        <li><b>{{ info.ExpiryDays }}</b><span>有效期限</span></li>
        <li><b>{{ info.StayDays }}</b><span>最长停留</span></li>
        <li><b>{{ info.AllowNums }}次</b><span>入境次数</span></li>
      </ul>
      <p class="hint"><i class="icon-guanyu"></i><span>有效期和停留时长以实际出签为准。</span></p>
    </header>
    <nav>
      <span :class="{on: index === 0}" @click="index = 0">产品详情</span>
      <span :class="{on: index === 1}" @click="index = 1">所需资料</span>
      <span :class="{on: index === 2}" @click="index = 2">温馨提示</span>
    </nav>
    <div class="content" v-html="getContent" v-show="!!getContent"></div>
    <ul class="crowd" v-show="index === 1">
      <li v-for="(v, i) in info.material" :key="v.title">
        <h4 @click="info.materialIndex = ( i === info.materialIndex ? null : i )"><span>{{ v.title }}</span><i class="icon-you"></i></h4>
        <div class="desc" :class="{ show: info.materialIndex === i}">
          <p v-for="sub in v.desc" :key="sub.Descs" v-html="sub.Descs"></p>
        </div>
      </li>
    </ul>
    <footer>
      <a><i class="icon-ceshi"></i><span>咨询</span></a>
      <button @click="createdOrder">开始办理</button>
    </footer>
  </main>
</template>

<script>
import filter from '@assets/js/filter';
export default {
  data () {
    return {
      info: {},
      index: 0,
    }
  },
  filters: {
    ...filter
  },
  computed: {
    getContent () {
      const { index, info } = this;
      let res;
      switch (index) {
        case 0: {
          res = info.PackageNote;
          break;
        }
        case 1: {
          res = false;
          break;
        }
        case 2: {
          res = info.Reminder;
          break;
        }
      }
      return res;
    }
  },
  created () {
    const { id = 98 } = this.$route.query;
    this.$axios.get('VisaProduct/detail/'+id).then(res => {
      const { product } = res;
      this.info = {
        ...product,
        Promises: product.Promise.split(',').filter(v => !!v),
        material: product.visa_files.reduce((obj, v) => {
          const { TypeName } = v;
          obj[TypeName].desc.push(v);
          return obj;
        }, [
          { desc: [], title: '在职人员' },
          { desc: [], title: '退休人员' },
          { desc: [], title: '自由职业者' },
          { desc: [], title: '学生' },
          { desc: [], title: '学龄前儿童' }
        ]),
        materialIndex: null
      };
      this.scrollTo();
    });
  },
  methods: {
    createdOrder () {
      const { info } = this;
      sessionStorage.setItem('visaInfo', JSON.stringify(info));
      this.$router.push({ name: 'visa_push' });
    }
  }
}
</script>
<style>
.content img {
  width: 100%;
}
</style> 
<style scoped src="./detail.css"></style>